import { useContext, useState} from 'react';
import './../index.css'
//import SearchCategories from '../components/SearchCategories';
import SearchZipCode from '../components/searchZipCode';
import HomePageSearchBox from '../components/HomePageSearchBox';
import SearchCountyName from '../components/SearchCountyName';
import Menu from '../components/menu';
import ToggleButton from '../components/ToggleButton';
import { AuthContext } from '../contexts/AuthContext';

import MenuDropdown from '../components/menuDropdown';

const HomePage = () =>
{

    const {countyName} = useContext(AuthContext);
    const [showSearchBar, setShowSearchBar] = useState(false); //for making search bar appear and dissapear.
    // const [zipCodePage, setZipCodePage] = useState(''); //for saving an instance of the zip code
    // const [countyNamePage, setCountyNamePage] = useState('');
    const [showCounty, setShowCounty] = useState(countyName !== '' ? true : false); //if state is false showZipCode and if true show County Name

    // Note: when i return to homepage from searhc reuslts after searching by county name, it returns to zip code search but the button says zip code.
    // Note: fixed by chnaging useState Hook
    return(
        <div>

            <div >

                <h2 className="search-title">Enter a Zip Code or County to get Started </h2>

                <div style={{display: 'flex',  justifyContent: 'center', flexDirection: 'row', gap: '10px'}}>
                    
                    {/* <SearchZipCode setShowSearchBar={setShowSearchBar} setZipCodePage={setZipCodePage}/>
                    <SearchCountyName setShowSearchBar={setShowSearchBar} setCountyNamePage={setCountyNamePage}/> */}
                    
                    {/* if a county is present in local storage, the zip code will be disabled.
                    if not, it will be enabled. */}
                    {/* {!showCounty && <SearchZipCode setShowSearchBar={setShowSearchBar}/>} */}
                    {<SearchZipCode setShowSearchBar={setShowSearchBar} showCounty={showCounty}/>}

                    {/* Add the toggle */}
                    <ToggleButton setShowCounty={setShowCounty} setShowSearchBar={setShowSearchBar}/>

                    {/* Inaccurate search results for county name (Inform Leia) */}
                    {/* {showCounty && <SearchCountyName setShowSearchBar={setShowSearchBar} />} */}
                    {<SearchCountyName setShowSearchBar={setShowSearchBar} showCounty={showCounty}/>}
                </div>

                {/* <text>{countyName}</text> */}
        
            </div>

            {showSearchBar && <HomePageSearchBox/>} {/*//to show search bar*/}


            {/*makes menu appear and moves instance of zip code to menu*/}
            {/* {showSearchBar && <Menu/>}  */}
            {showSearchBar && <MenuDropdown/>} 
            {/* makes menu appear and moves instance of zip code to menu */}
            <br></br>
        </div>
    );
};

export default HomePage;
